//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
let d=[[[0,"FilterType",1,0],[0,"NameFilter",1,0]],[[["num_stocks","objects"],"GetSortedList",{},0,0],[["objects"],"SetSortedList",{},1,0],[["objects"],"DeleteStocks",{},1,0]],[]];
SPLM.Routing.StockBrowserBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.StockBrowserBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.StockBrowserBuilder.TypeFilter = Object.freeze({
    "All" : "All", "Stock" : "Stock", "OverStock" : "OverStock", "FillerStock" : "FillerStock", "SpaceReservation" : "SpaceReservation", "FittingOverstock" : "FittingOverstock"});

export default SPLM;